const testimonials = [
  {
    name: "Robert L.",
    location: "Eagan, MN",
    rating: 5,
    text: "I work at Thomson Reuters and got assigned to a client project in London with ten days notice. My passport had expired during the pandemic. Fast Passport Center reviewed my documents, submitted my renewal, and I had my passport back in five business days. Made my flight. Exceptional professional service.",
    service: "Passport Renewal",
  },
  {
    name: "The Peterson Family",
    location: "Cedar Grove, Eagan",
    rating: 5,
    text: "We planned a summer vacation to Italy and realized my son's passport had expired — he was 13 when it was issued so it was only 5 years. Fast Passport Center walked us through the child passport process, reviewed all our documents, and got his passport back in seven business days. We made our trip with time to spare.",
    service: "Child Passport",
  },
  {
    name: "Angela M.",
    location: "Near Lone Oak Road, Eagan",
    rating: 5,
    text: "Our company booked me for a healthcare conference in Dublin and I noticed my passport expired six months ago. Called Fast Passport Center on Monday, shipped overnight from the Eagan FedEx, and had my renewed passport Thursday. The whole process was smooth and exactly as promised.",
    service: "Emergency Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function EaganTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Eagan &amp; South Metro Travelers Say About Our Emergency &amp; Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Eagan, Cedar Grove, and Dakota County travelers who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}